import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ViewChild,
  Injectable,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  NgbModal,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbModalOptions,
  NgbActiveModal
} from '@ng-bootstrap/ng-bootstrap';
import { Observable, of, Subject } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal, Collapse } from 'bootstrap';
import { AddSubscription } from '../../services/add-subscription.service';
import { MasterDataService } from '../../services/masterdata.service';
import { Session } from '../../models/Session';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SessionService } from '../../services/session.service';
import { AddEditPricingModalComponent } from '../add-edit-pricing-modal/add-edit-pricing-modal.component';
import { DatePipe } from '@angular/common';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { UserRolesService } from '../../services/user-roles.service';
import { UserRoleDetails } from '../../models/user-role-details';
import { Subscription } from '../../models/subscription';
import { SessionStorageService } from "../../core/services/session-storage.service";
import $ from 'jquery';
import 'bootstrap';
import { IApiResponse } from "../../core/models/api-response.model";
import { OrphanSessionData } from "../../models/orphan-session-model"
import { AssignSessionsToSubsInputDTO } from "../../models/assign-session-subscription-model";
import { AppConfig } from '../../design/app';

declare var bootstrap: any;
@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  toInteger(value: any): number {
    return parseInt(`${value}`, 10);
  }
  isNumber(value: any): value is number {
    return !isNaN(this.toInteger(value));
  }

  padNumber(value: number) {
    if (this.isNumber(value)) {
      return `0${value}`.slice(-2);
    } else {
      return '';
    }
  }
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length == 1 && this.isNumber(dateParts[0])) {
        return { day: this.toInteger(dateParts[0]), month: null, year: null };
      } else if (
        dateParts.length == 2 &&
        this.isNumber(dateParts[0]) &&
        this.isNumber(dateParts[1])
      ) {
        return {
          day: this.toInteger(dateParts[1]),
          month: this.toInteger(dateParts[0]),
          year: null,
        };
      } else if (
        dateParts.length == 3 &&
        this.isNumber(dateParts[0]) &&
        this.isNumber(dateParts[1]) &&
        this.isNumber(dateParts[2])
      ) {
        return {
          day: this.toInteger(dateParts[1]),
          month: this.toInteger(dateParts[0]),
          year: this.toInteger(dateParts[2]),
        };
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    return date
      ? `${this.isNumber(date.month) ? this.padNumber(date.month) : ''}/${
          this.isNumber(date.day) ? this.padNumber(date.day) : ''
        }/${date.year}`
      : '';
  }
}
@Component({
    selector: 'app-subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['./subscription.component.less'],
    providers: [
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubscriptionComponent implements OnInit, OnDestroy {
  @Input() session: Session;
  @ViewChild('wbsCodeContent', { static: true }) private wbsCodeContent;
  subscriptionForm: FormGroup;
  masterData: any;
  showLoader: boolean = false;
  subscription: Subject<void> = new Subject<void>();
  sponsoringCountryList: Array<any>;
  showNAFields: boolean = false;
  serviceFunctionList: Array<any>;
  industriesList: Array<any>;
  sectorList: Array<any>;
  isCommType: boolean = false;
  isUSCountry: boolean = false;
  textLimitErrorPPMD: boolean = false;
  showPPMDAsTextInput: boolean = true;
  subadmins: Array<any> = [];
  selectedSubAdministrators: Array<any> = [];
  selectedProposedSubAdmins: string = '';
  selectedCompanyFacilitators: Array<any> = [];
  selectedSubCoordinators: Array<any> = [];
  selectedCompanyAdmins: Array<any> = [];
  isAudienceSelected: boolean = false;
  paramId: number;
  isEditMode: boolean = false;
  editSubscriptionData: Subscription;
  subscriptionID: string = '';
  IsDateInvalid: boolean = false;
  invalidDateErrorMsg: string = '';
  minDate: { year: number; month: number; day: number };
  PPMDEmail: string = '';
  PPMDLastName: string = '';
  PPMDFirstName: string = '';
  ppmdFirstLastName: string = '';
  enableAdd: boolean = false;
  isCommTypeEnable: boolean = false;
  SECRestrictedList: Array<any> = [];
  SECRestrictedListOnAudienceSelect: Array<any>;
  isNonClient: boolean = false;
  minStartDate: any;
  wbsCodesList: any[] = [];
  isSurchargeWbsCodes: boolean = false;
  surchargeWbsCodeList: any[] = [];
  paymentTermsList = [
    { value: 1, name: 'Upfront' },
    { value: 2, name: 'Quarterly' },
    { value: 3, name: 'Periodic' },
    { value: 4, name: 'Other' },
  ];
  paymentTerms = [];
  currencyList = [
    { value: 4, name: 'USD ($)' },
    { value: 5, name: 'AUD ($)' },
    { value: 3, name: 'CAD ($)' },
    { value: 1, name: 'EUR (€)' },
    { value: 2, name: 'GBP (£)' },
  ];
  pricingTableData = [];
  isDateChange: boolean = false;
  isPrepaid: boolean = false;
  isSubmitted: boolean = false;
  isValidCompany: boolean = false;
  errorMessage: string = '';
  pricingTableError: string = '';
  showRefresh: boolean = false;
  isRefreshClicked: boolean = true;
  isInValidCompAdmin: boolean = false;
  isInValidCompCo: boolean = false;
  isInValidCompFacilitator: boolean = false;
  isInValidSubPPMD: boolean = false;
  isServiceNAMandatory = false;
  isIndustryNAMandatory = false;
  isSectorNAMandatory = false;
  isPleaseSpecifyMandatory = false;
  isDisplaySubText = true;
  initialFormValue: string = '';
  isValueChange = false;
  eventId: string = '';
  eventName: string = '';
  eventLink: string = '';
  eventUrl: string = '';
  validForm: boolean = false;
  //Changes for US 3417373
  dateofPurchaseToDisableOnProd: string = '10/06/2020';
  subscriptionToDisableRowOnProd: string = '9115092';
  userRoleID: any = '';
  userRoleDetails: UserRoleDetails;
  subscriptionPpmdEmail: string = '';
  commentsPlaceholder: string = '';
  selectedStartDate: Date | null = null;
  selectedEndDate: Date | null = null;
  public subdomains: string[] = [];
  invalidEmailFormat: boolean = false;
  invalidEmailDomain: boolean = false;
  public sampleColumns: any;
  public sampleData: [];
  public sessionData: [];
  public allowCheckbox: boolean = true;
  public iseventRegistered: boolean = true;
  public allowPagination: boolean = false;
  public isClientSidePagination: boolean = true;
  public isAddSubscriptionModule: boolean = true;
  public searchGridHeight = '400px';
  TotalNumberOfUsers: number = 0;
  TotalActualUsage: number = 0;
  TotalChargeback: number = 0;
  TotalSurcharge: number = 0;
  associateSessionIsChecked: boolean = false;
  orphanSessionData: OrphanSessionData[];
  disableAddAssosiateSession: boolean = true;
  selectAllCheckboxDisabled: boolean = false;
  rowCheckboxDisabled: boolean = false;
  disableAssosiateSession: boolean = false;
  sessionsAssosiated: boolean = false;
  sessionAssosiationError: string = "";
  WBSCodeError: boolean = false;
  invalidSubsAdmin: boolean = false;
  IDCopied: boolean = false;
  // WBS-related properties for subscription module
  isWBSMandatory: boolean = false;
  wbsDisable: boolean = false;
  selectedCompanyDunsID: string = '';
  invalidWBS: boolean = false;
  invalidWBSDunsID: boolean = false;
  searchingWBS: boolean = false;
  searchFailedWBS: boolean = false;
  hasInactiveWBSInPricing: boolean = false;
  inactiveWBSErrorMessage: string = '';
  mdmWbsDeploymentDate: string = '';
  isSubscriptionCreatedBeforeMdmWbsDeploymentDate: boolean = true;
  normalizeWbsCode(code: string): string {
    return (code || '').toUpperCase().trim();
  }

  private parseDateValue(value: any): Date | null {
    if (!value) {
      return null;
    }

    const rawValue = typeof value === 'string' ? value.trim() : value;
    const normalizedValue =
      typeof rawValue === 'string'
        ? rawValue.replace(/\s(CST|CDT|EST|EDT|PST|PDT)$/i, '').trim()
        : rawValue;

    const parsedDate = new Date(normalizedValue);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

 

  private isCreatedBeforeDeploymentDate(createdDate: any, deploymentDate: any): boolean {
    const parsedCreatedDate = this.parseDateValue(createdDate);
    const parsedDeploymentDate = this.parseDateValue(deploymentDate);

    if (!parsedCreatedDate || !parsedDeploymentDate) {
      return true;
    }

    return parsedCreatedDate.getTime() < parsedDeploymentDate.getTime();
  }
  constructor(
    private masterDataService: MasterDataService,
    private addSubscriptionService: AddSubscription,
    private sessionService: SessionService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private datepipe: DatePipe,
    private router: Router,
    public userRoleService: UserRolesService,
    private sessionStorageService: SessionStorageService,
  ) {
    this.session = new Session();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.paramId = params['id'];
    });
    this.sampleData = [];
  }

  ngOnInit(): void {
    this.showLoader = true;
    this.mdmWbsDeploymentDate = (AppConfig as any)?.MDMWBSdeploymentDate || '';
    this.minStartDate = this.convertDateToNgbDate(new Date());
    this.userRoleService.setDisableUserRoleList(true);
    this.initializeForm();
    this.getUserRoleList();
    this.getSubDomains();
    this.setColumnHeading();
  }
  getSubDomains(): void {
    this.addSubscriptionService.getSubDomains()
      .subscribe((res: IApiResponse<string[]>) => {
        if (res.Success) {
          this.subdomains = res.Data;
        }
      }, (error) => {
        console.log(error);
      });
  }
 
  getMasterData() {
    this.masterDataService
      .getMasterDataDetails()
      .pipe(takeUntil(this.subscription))
      .subscribe((masterData) => {
        if (masterData) {
          this.masterData = masterData;
          this.SECRestrictedList = masterData.SECRestriction;
          this.loadIndustryDropdown();
          this.loadServiceFunctionDropdown();
          this.setDataOnLoad();
          if (this.paramId) {
            this.isEditMode = true;
            this.addSubscriptionService
              .getEditSubscription(this.paramId)
              .subscribe((res) => {
                if (res) {
                  this.addSubscriptionService.editSubscriptionResponse = res;
                  this.editSubscriptionData = res;
                  this.subscriptionID = this.editSubscriptionData.SubscriptionuniqueID
                  this.initializeForm('edit');
                  this.setEditSubscriptionData();
                  this.showLoader = false;
                }
              });
          } else {
            this.showLoader = false;
          }
        }
      });
  }
  getUserRoleList() {
    this.showLoader = true;
    this.userRoleService.getUserRoles().subscribe((res) => {
      this.userRoleID = res.HighestRoleId;
      this.userRoleDetails = res;
      if (this.userRoleID != 1) {
        this.onPriceOptionChange('Prepaid', true);
        this.subscriptionForm.controls['Pricingoption'].setValue('Prepaid');
      }
      this.getMasterData();
    });
  }
  initializeForm(type?): void {
    if (type) {
      this.subscriptionForm = new FormGroup({
        SessionAudience: new FormControl(
          this.editSubscriptionData.SessionAudience,
          Validators.required
        ),
        SubscriptionuniqueID: new FormControl({
          value: this.editSubscriptionData.SubscriptionuniqueID,
          disabled: true,
        }),
        Company: new FormControl('', Validators.required),
        ClientProgramID: new FormControl(
          this.editSubscriptionData.ClientProgramID
        ),
        SecRestrictedID: new FormControl(
          this.editSubscriptionData.SecRestrictedID,
          Validators.required
        ),
        SponsoringCountryID: new FormControl(
          this.editSubscriptionData.SponsoringCountryID,
          Validators.required
        ),
        ParticipantGroup: new FormControl(
          this.editSubscriptionData.ParticipantGroup ? this.editSubscriptionData.ParticipantGroup : ""
        ),
        StartDate: new FormControl(
          {
            value: this.convertDateToNgbDate(
              this.editSubscriptionData.StartDate
            ),
            disabled: true,
          },
          Validators.required
        ),
        EndDate: new FormControl(
          this.convertDateToNgbDate(this.editSubscriptionData.EndDate),
          Validators.required
        ),
        ServiceFunctionID: new FormControl(
          this.editSubscriptionData.ServiceFunctionID,
          Validators.required
        ),
        IndustryID: new FormControl(
          this.editSubscriptionData.IndustryID,
          Validators.required
        ),
        SectorID: new FormControl(
          this.editSubscriptionData.SectorID,
          Validators.required
        ),
        SubscriptionType: new FormControl(
          this.editSubscriptionData.SubscriptionType.toLowerCase(),
          Validators.required
        ),
        LinkType: new FormControl(
          this.editSubscriptionData.LinkType.toLowerCase().split(' ').join(''),
          Validators.required
        ),
        Pricingoption: new FormControl(
          this.editSubscriptionData.Pricingoption,
          Validators.required
        ),
        PaymenttermsID: new FormControl(
          this.editSubscriptionData.PaymenttermsID,
          Validators.required
        ),
        PleaseSpecify: new FormControl(this.editSubscriptionData.PleaseSpecify),
        CurrencyID: new FormControl(
          this.editSubscriptionData.CurrencyID,
          Validators.required
        ),
        subscriptionPPMD: new FormControl(
          this.editSubscriptionData.PPMDFirstName &&
          this.editSubscriptionData.PPMDLastName
            ? {
                Name_First: this.editSubscriptionData.PPMDFirstName,
                Name_Last: this.editSubscriptionData.PPMDLastName,
                AD_EmailAdress: this.editSubscriptionData.PPMDEmail,
              }
            : this.editSubscriptionData.PPMDEmail
            ? this.editSubscriptionData.PPMDEmail
            : ''
        ),
        SubscriptionAdmins: new FormControl(null),
        ProposedSubscriptionAdmins: new FormControl(this.editSubscriptionData.ProposedSubscriptionAdmins),
        CompanyFacilitators: new FormControl(null),
        CompanyCoordinators: new FormControl(null),
        CompanyAdministrators: new FormControl(null),
        Comments: new FormControl(this.editSubscriptionData.Comments),
        SubscriptionName: new FormControl({
          value: this.editSubscriptionData.SubscriptionName,
          disabled: true,
        }),
        Status: new FormControl(
          this.editSubscriptionData.Status,
          Validators.required
        ),
        ServiceFunctionText: new FormControl({
          value: this.editSubscriptionData.ServiceFunctionText,
          disabled:
            this.editSubscriptionData.ServiceFunctionText !== '' ? false : true,
        }),
        IndustryText: new FormControl({
          value: this.editSubscriptionData.IndustryText,
          disabled:
            this.editSubscriptionData.IndustryText !== '' ? false : true,
        }),
        SectorText: new FormControl({
          value: this.editSubscriptionData.SectorText,
          disabled: this.editSubscriptionData.SectorText !== '' ? false : true,
        }),
      });
      
    } else {
      this.subscriptionForm = new FormGroup({
        SessionAudience: new FormControl('', Validators.required),
        SubscriptionuniqueID: new FormControl(''),
        Company: new FormControl('', Validators.required),
        ClientProgramID: new FormControl(null),
        SecRestrictedID: new FormControl(null, Validators.required),
        SponsoringCountryID: new FormControl(null, Validators.required),
        ParticipantGroup: new FormControl(''),
        StartDate: new FormControl(null, Validators.required),
        EndDate: new FormControl(null, Validators.required),
        ServiceFunctionID: new FormControl(null, Validators.required),
        IndustryID: new FormControl(null, Validators.required),
        SectorID: new FormControl(null, Validators.required),
        SubscriptionType: new FormControl('', Validators.required),
        LinkType: new FormControl('', Validators.required),
        Pricingoption: new FormControl(null, Validators.required),
        PaymenttermsID: new FormControl(null, Validators.required),
        PleaseSpecify: new FormControl({ value: '', disabled: true }),
        CurrencyID: new FormControl(null, Validators.required),
        subscriptionPPMD: new FormControl(null),
        SubscriptionAdmins: new FormControl(null),
        ProposedSubscriptionAdmins: new FormControl(null),
        CompanyFacilitators: new FormControl(null, Validators.required),
        CompanyCoordinators: new FormControl(null, Validators.required),
        CompanyAdministrators: new FormControl(null, Validators.required),
        Comments: new FormControl(''),
        SubscriptionName: new FormControl({ value: '', disabled: true }),
        Status: new FormControl('Approval Pending', Validators.required),
        ServiceFunctionText: new FormControl({ value: '', disabled: true }),
        IndustryText: new FormControl({ value: '', disabled: true }),
        SectorText: new FormControl({ value: '', disabled: true }),
      });
    }
  }

  copySubscriptionID() {
    if (this.subscriptionID) {
      navigator.clipboard.writeText(this.subscriptionID).then(() => {
        this.IDCopied = true;
        setTimeout(() => {
          this.IDCopied = false;
        }, 2000);
      }).catch(err => {
      });
    }
  }


  ScrollIntoView(elem: string): void {
    setTimeout(() => {
      document
        .querySelector(elem)
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

  setEditSubscriptionData() {
    this.isSubscriptionCreatedBeforeMdmWbsDeploymentDate = this.isCreatedBeforeDeploymentDate(
      this.editSubscriptionData.createdDate,
      this.mdmWbsDeploymentDate
    );

    if (this.userRoleID != 1 && this.userRoleID != 3) {
      this.minDate = this.convertDateToNgbDate(
        this.editSubscriptionData.EndDate
      );
    } else {
      this.minDate = this.convertDateToNgbDate(
      this.editSubscriptionData.StartDate
    );
    }
    this.selectedSubAdministrators =
      this.editSubscriptionData.SubscriptionAdmins;
    this.selectedProposedSubAdmins = this.editSubscriptionData.ProposedSubscriptionAdmins;
    this.selectedCompanyFacilitators = this.editSubscriptionData
      .CompanyFacilitators
      ? this.editSubscriptionData.CompanyFacilitators
      : [];
    this.selectedSubCoordinators = this.editSubscriptionData.CompanyCoordinators
      ? this.editSubscriptionData.CompanyCoordinators
      : [];
    this.selectedCompanyAdmins = this.editSubscriptionData.CompanyAdministrators
      ? this.editSubscriptionData.CompanyAdministrators
      : [];
    this.PPMDFirstName = this.editSubscriptionData.PPMDFirstName;
    this.PPMDLastName = this.editSubscriptionData.PPMDLastName;
    this.PPMDEmail = this.editSubscriptionData.PPMDEmail;
    this.ppmdFirstLastName = `${this.PPMDFirstName} ${this.PPMDLastName}`;
    this.sponsoredCountryChange(
      this.editSubscriptionData.SponsoringCountryID,
      true
    );
    this.onPriceOptionChange(this.editSubscriptionData.Pricingoption);
    this.subscriptionForm.controls['PaymenttermsID'].setValue(
      this.editSubscriptionData.PaymenttermsID
    );
    this.onSessionAudienceChange(
      this.editSubscriptionData.SessionAudience,
      true
    );
    this.isCommType =
      this.subscriptionForm.controls['SubscriptionType'].value.toLowerCase() ==
      'commercialization'
        ? true
        : false;
    if (this.isCommType) {
      this.subscriptionForm.controls['CompanyAdministrators'].setValidators([
        Validators.required,
      ]);
      this.subscriptionForm.controls['CompanyCoordinators'].setValidators([
        Validators.required,
      ]);
      this.subscriptionForm.controls['CompanyFacilitators'].setValidators([
        Validators.required,
      ]);
    } else {
      if (this.selectedSubAdministrators.length == 0 && (this.selectedProposedSubAdmins == '' || this.selectedProposedSubAdmins == null )) {
        this.subscriptionForm.controls['SubscriptionAdmins'].setValidators([
          Validators.required,
        ]);
        this.subscriptionForm.controls['ProposedSubscriptionAdmins'].setValidators([
          Validators.required,
        ]);
      }
    }
    this.pricingTableData = this.isPrepaid
      ? this.editSubscriptionData.PrepaidPricingInfo
        ? this.editSubscriptionData.PrepaidPricingInfo
        : []
      : this.editSubscriptionData.OpenPricingInfo
      ? this.editSubscriptionData.OpenPricingInfo
      : [];
    this.pricingTableData.forEach((value, i) => {
      value.id = i + 1;
      value.wbsCodesText = this.displayWbsCodes(value);
      value.ChargeBack =
        value.ChargeBack % 1 != 0
          ? value.ChargeBack.toFixed(2)
          : value.ChargeBack;
      if (!this.isPrepaid) {
        value.durationText = this.displayDuration(value);
      } else {
        value.DateOfPurchase = this.datepipe.transform(
          new Date(value.DateOfPurchase),
          'MM/dd/yyyy'
        );
      }
      this.TotalChargeback += value.ChargeBack;
      this.TotalNumberOfUsers += value.NoOfUsers;
      this.TotalActualUsage += value.ActualUsage;
      if (value.Surcharge > 0) { 
        this.TotalSurcharge += value.Surcharge;
      }
      // Mark all existing WBS codes as linked to this subscription
      // so that inactive existing codes do not block form submission
      if (value.WBSCodesList) {
        value.WBSCodesList.forEach((wbs: any) => { wbs.isExistingWbs = true; });
      }
      if (value.SurchargeWBSCodesList) {
        value.SurchargeWBSCodesList.forEach((wbs: any) => { wbs.isExistingWbs = true; });
      }
    });
    this.enableDisablePricingAdd();
    this.addSubscriptionService
      .getCompanies(this.editSubscriptionData.Company.trim(), 0)
      .subscribe((res) => {
        if (res && res.length > 0) {
          const val = res.find(
            (data) => data.Name === this.editSubscriptionData.Company.trim()
          )
            ? res.find(
                (data) => data.Name === this.editSubscriptionData.Company.trim()
              )
            : { Name: this.editSubscriptionData.Company };
          this.subscriptionForm.controls['Company'].setValue(val);
          this.selectedCompanyDunsID = res[0]?.DunsID;
        } else {
          this.subscriptionForm.controls['Company'].setValue({
            Name: this.editSubscriptionData.Company,
          });
        }
        this.initialFormValue = JSON.stringify(this.subscriptionForm.value);
      });
    this.industryChange(this.editSubscriptionData.IndustryID);
    this.eventId = this.editSubscriptionData.EventID;
    this.eventName = this.editSubscriptionData.EventName;
    this.eventLink = this.editSubscriptionData.EventLink;

    if (this.eventName) {
      this.eventUrl = this.eventLink + this.eventId;
    }
    // Disable all fields if userRoleID is 6 (subs admin)
    if (this.userRoleID === 6 && this.subscriptionForm) {
      Object.keys(this.subscriptionForm.controls).forEach(controlName => {
        const control = this.subscriptionForm.controls[controlName];
        control.disable();
        // Perform any operations needed on each control
      });
    }
    this.disableAssosiateSession = this.editSubscriptionData.TotalSessions >= 1 && this.subscriptionForm.controls["LinkType"].value == "singlelink" ? true : false;
    
    // Validate existing WBS codes in pricing information if data exists
    if (this.pricingTableData && this.pricingTableData.length > 0) {
      this.validateWBSCodesInPricing();
    }
  }

  onSessionAudienceChange(audience: string, isDataPopulate?): void {
    this.isDisplaySubText = false;
    this.isAudienceSelected = true;
    this.isNonClient = false;
    setTimeout(() => {
      const element = document.querySelector('#accordion .accordion1');
      if (element) {
        element.classList.add('show');
        element.classList.remove('collapse');
      }
      // var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion1'), {
      //   show: true
      //   });

      //  $("#accordion .accordion1").collapse("show");
    }, 100);
    this.isCommTypeEnable = audience !== 'ExternalClient' ? false : true;
    if (audience === 'ExternalClient') {
      this.isDisplaySubText =
        this.subscriptionForm.controls['SponsoringCountryID'].value == 23 ||
        this.subscriptionForm.controls['SponsoringCountryID'].value == null
          ? true
          : false;
      this.subscriptionForm.controls['SecRestrictedID'].enable();
      this.SECRestrictedListOnAudienceSelect = this.SECRestrictedList.filter(
        (res) => res.SecRestrictionID == 1 || res.SecRestrictionID == 2
      );
    } else if (audience === 'ExternalNonClient') {
      this.subscriptionForm.controls['SecRestrictedID'].disable();
      this.isNonClient = true;
    } else {
      this.subscriptionForm.controls['SecRestrictedID'].enable();
      this.SECRestrictedListOnAudienceSelect = this.SECRestrictedList;
    }
    if (!isDataPopulate) {
      this.isValueChange = true;
      this.subscriptionForm.controls['SecRestrictedID'].setValue(null);
      if (this.userRoleID != 1) {
        this.subscriptionForm.controls['SubscriptionType'].setValue('standard');
        this.onSubscriptionTypeChange('standard');
      } else {
        this.subscriptionForm.controls['SubscriptionType'].setValue('');
      }
      this.isCommType = false;
    } else {
      this.subscriptionForm.controls['SecRestrictedID'].setValue(
        this.editSubscriptionData.SecRestrictedID
      );
    }
    if (isDataPopulate && this.userRoleID == 6) {
      this.subscriptionForm.controls['SecRestrictedID'].disable();
    }
    this.subscriptionForm.controls['SecRestrictedID'].updateValueAndValidity();
    this.checkValidCompany(audience);
    this.updateWBSMandatoryStatus();
  }

  onCompanySelect(value): void {
    if (typeof value == 'string') {
      if (this.subscriptionForm.controls['Company'].value['Name'] != value) {
        this.isValueChange = true;
        this.subscriptionForm.controls['ClientProgramID'].setValue(null);
        this.subscriptionForm.controls['IndustryID'].setValue(null);
        this.subscriptionForm.controls['SectorID'].setValue(null);
        this.isValidCompany = false;
        this.selectedCompanyDunsID = '';
      }
    } else {
      // Capture company's DunsID for WBS validation
      this.selectedCompanyDunsID = value.DunsID || '';
      
      //Fix for bug 3942312
      if (this.industriesList) {
        const industryObj: any = this.industriesList.find(
          (x) => x.ID == value.IndustryID
        );
        if (industryObj) {
          this.subscriptionForm.controls['IndustryID'].setValue(
            value.IndustryID
          );
        } else {
          this.subscriptionForm.controls['IndustryID'].setValue(null);
        }
      } else {
        this.subscriptionForm.controls['IndustryID'].setValue(null);
      }

      this.subscriptionForm.controls['ClientProgramID'].setValue(
        value.ClientProgramID
      );

      this.industryChange(value.IndustryID, true);
      this.isValidCompany = true;
      //Fix for bug 3942312
      if (this.sectorList) {
        const sectorObj: any = this.sectorList.find(
          (x) => x.SectorID == value.SectorID
        );
        if (sectorObj) {
          this.subscriptionForm.controls['SectorID'].setValue(value.SectorID);
        } else {
          this.subscriptionForm.controls['SectorID'].setValue(null);
        }
      } else {
        this.subscriptionForm.controls['SectorID'].setValue(null);
      }
    }
    this.validateWBSCodesInPricing();
  }

  formatMatches = (value: any) => value.Name || '';

  searchCompany = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term) =>
        this.addSubscriptionService.getCompanies(term.trim(), 0).pipe(
          catchError(() => {
            return of([]);
          })
        )
      )
    );

  setDataOnLoad() {
    this.sponsoringCountryList = this.masterData['Countries']
      ? this.masterData['Countries'].filter(
        (country) => country.ID != 266)
      : [];
    if (this.userRoleID == 3) {
      this.sponsoringCountryList = this.sponsoringCountryList.filter((res) =>
        this.userRoleDetails.AssignedCountries.includes(res.ID)
      );
    }
    if (
      this.sponsoringCountryList.length == 1 &&
      this.sponsoringCountryList[0].ID == '23'
    ) {
      this.currencyList = [{ value: 4, name: 'USD ($)' }];
    }
  }

  convertDateToNgbDate(date) {
    const dt = new Date(date);
    const dateObj = {
      year: dt.getFullYear(),
      month: dt.getMonth() + 1,
      day: dt.getDate(),
    };
    return dateObj;
  }
  setStartDate(event: any) {
    this.subscriptionForm.controls['StartDate'].setValue(
      this.selectedStartDate
    );
  }
  setEndDate(event: any) {
    const endDate = {
      year: this.selectedEndDate.getFullYear(),
      month: this.selectedEndDate.getMonth(),
      day: this.selectedEndDate.getDate(),
    };
    this.subscriptionForm.controls['EndDate'].setValue(endDate);
  }

  setEnddate() {
    if (this.subscriptionForm.value && this.subscriptionForm.value.StartDate) {
      this.onStartDateSelect(this.subscriptionForm.value.StartDate);
    } else {
      this.enableAdd = false;
      this.pricingTableData = [];
      if (this.userRoleID == 1) {
        this.subscriptionForm.controls['Pricingoption'].setValue(null);
        this.subscriptionForm.controls['PaymenttermsID'].setValue(null);
      }
      this.subscriptionForm.controls['PleaseSpecify'].setValue('');
      this.subscriptionForm.controls['SponsoringCountryID'].value == '23'
        ? this.subscriptionForm.controls['CurrencyID'].setValue(4)
        : this.subscriptionForm.controls['CurrencyID'].setValue(null);
    }
  }

  onStartDateSelect(date): void {
    this.selectedStartDate = date;

    this.isValueChange = true;
    const selectedDate = new Date(date.year, date.month - 1, date.day);
    if (this.userRoleID == 1 || this.userRoleID == 3) {
      this.minDate = this.convertDateToNgbDate(selectedDate); // to disabled the date before start date for End date field
    }
    const tempDate = new Date(
      selectedDate.setDate(selectedDate.getDate() + 365)
    );
    const endDate = {
      year: tempDate.getFullYear(),
      month: tempDate.getMonth() + 1,
      day: tempDate.getDate(),
    };
    if (this.pricingTableData.length > 0) {
      if (this.userRoleID == 1) {
        this.subscriptionForm.controls['Pricingoption'].setValue(null);
        this.subscriptionForm.controls['PaymenttermsID'].setValue(null);
      }
      this.subscriptionForm.controls['SponsoringCountryID'].value == '23'
        ? this.subscriptionForm.controls['CurrencyID'].setValue(4)
        : this.subscriptionForm.controls['CurrencyID'].setValue(null);
      this.pricingTableData = [];
    }

    this.subscriptionForm.get('EndDate').setValue(endDate);
    this.selectedEndDate = new Date(endDate.year, endDate.month, endDate.day);
    if (this.userRoleID != 1 && this.userRoleID != 3 ){
      const selectedminEndDate = new Date(endDate.year, endDate.month - 1, endDate.day);
      this.minDate = this.convertDateToNgbDate(selectedminEndDate); // to disabled the date before start date for End date field
    }
    this.validateDates();
    this.enableDisablePricingAdd();
  }

  enableDisablePricingAdd(): void {
    if (
      this.subscriptionForm.controls['Pricingoption'].value &&
      this.subscriptionForm.controls['PaymenttermsID'].value &&
      this.subscriptionForm.controls['CurrencyID'].value &&
      this.subscriptionForm.controls['StartDate'].value &&
      this.subscriptionForm.controls['StartDate'].value.year &&
      this.subscriptionForm.controls['EndDate'].value &&
      this.subscriptionForm.controls['EndDate'].value.year
    ) {
      if (this.subscriptionForm.controls['PaymenttermsID'].value == '4') {
        if (this.subscriptionForm.controls['PleaseSpecify'].value != '') {
          this.enableAdd = true;
        } else {
          this.enableAdd = false;
        }
      } else {
        this.enableAdd = true;
      }
    } else {
      this.enableAdd = false;
    }
    if (this.pricingTableData.length > 0) {
      this.pricingTableData.forEach((res) => {
        res.DateOfPurchase = this.datepipe.transform(
          res.DateOfPurchase,
          'MM/dd/yyyy'
        );
        if (new Date(res.DateOfPurchase) > new Date()) {
          this.enableAdd = false;
        }
      });
    }
    if (
      this.isEditMode &&
      ((this.subscriptionForm.controls['Pricingoption'].value == 'Open' &&
        this.pricingTableData.length > 0) ||
        new Date(this.editSubscriptionData.StartDate) > new Date())
    ) {
      this.enableAdd = false;
    }
    if (
      this.isEditMode &&
      this.pricingTableData.length == 0 &&
      this.subscriptionForm.controls['EndDate'].value &&
      this.subscriptionForm.controls['EndDate'].value.year &&
      this.subscriptionForm.controls['PaymenttermsID'].value != null
    ) {
      this.enableAdd = true;
    }
    if (
      this.isEditMode &&
      this.subscriptionForm.controls['PaymenttermsID'].value == '4' &&
      this.subscriptionForm.controls['PleaseSpecify'].value == ''
    ) {
      this.enableAdd = false;
    }
  }
  validateDates(): void {
    /* debugger;*/
    const startDate = this.subscriptionForm.get('StartDate')
      ? this.subscriptionForm.get('StartDate').value
      : '';
    const endDate = this.subscriptionForm.get('EndDate')
      ? this.subscriptionForm.get('EndDate').value
      : '';

    if (
      startDate != '' &&
      startDate != null &&
      endDate != '' &&
      endDate != null
    ) {
      const sessionStartDate = new Date(
        startDate.year,
        startDate.month - 1,
        startDate.day
      );
      const sessionEndDate = new Date(
        endDate.year,
        endDate.month - 1,
        endDate.day
      );

      if (sessionStartDate > sessionEndDate) {
        this.IsDateInvalid = true;
        this.invalidDateErrorMsg = 'From Date should be greater than To Date.';
      }

      if (this.isEditMode) {
        if (
          this.editSubscriptionData.SessionMaxEndDate != null ||
          this.editSubscriptionData.SessionMaxEndDate != undefined ||
          this.editSubscriptionData.SessionMaxEndDate.toString() !== ''
        ) {
          if (
            new Date(this.editSubscriptionData.SessionMaxEndDate) >
            sessionEndDate
          ) {
            this.IsDateInvalid = true;
            this.invalidDateErrorMsg =
              'There are sessions available for the selected duration, please update the end date';
          } else {
            this.IsDateInvalid = false;
            this.invalidDateErrorMsg = '';
          }
        } else {
          this.IsDateInvalid = false;
          this.invalidDateErrorMsg = '';
        }
      } else {
        this.IsDateInvalid = false;
        this.invalidDateErrorMsg = '';
      }
    }
    if (
      this.subscriptionForm.controls['EndDate'].value == null ||
      !this.subscriptionForm.controls['EndDate'].value.year
    ) {
      if (this.userRoleID == 1) {
        this.subscriptionForm.controls['Pricingoption'].setValue(null);
        this.subscriptionForm.controls['PaymenttermsID'].setValue(null);
      }
      this.subscriptionForm.controls['SponsoringCountryID'].value == '23'
        ? this.subscriptionForm.controls['CurrencyID'].setValue(4)
        : this.subscriptionForm.controls['CurrencyID'].setValue(null);
      this.pricingTableData = [];
      this.showRefresh = false;
      this.isRefreshClicked = true;
      this.enableAdd = false;
    } else {
      this.enableDisablePricingAdd();
    }
  }

  onEndDateSelect(data): void {
    this.selectedEndDate = data;
    debugger;
    this.isValueChange = true;
    if (this.pricingTableData.length > 0 && !this.isEditMode) {
      if (this.userRoleID == 1) {
        this.subscriptionForm.controls['Pricingoption'].setValue(null);
        this.subscriptionForm.controls['PaymenttermsID'].setValue(null);
      }
      this.subscriptionForm.controls['SponsoringCountryID'].value == '23'
        ? this.subscriptionForm.controls['CurrencyID'].setValue(4)
        : this.subscriptionForm.controls['CurrencyID'].setValue(null);
      this.pricingTableData = [];
    } else if (
      !this.isPrepaid &&
      this.isEditMode &&
      this.pricingTableData.length > 0
    ) {
      this.showRefresh = true;
      this.isRefreshClicked = false;
      this.enableAdd = false;
    }
    this.validateDates();
  }

  sponsoredCountryChange(countryId, isEditData?): void {
    this.isDisplaySubText =
      countryId == 23 &&
      this.subscriptionForm.controls['SessionAudience'].value ==
        'ExternalClient'
        ? true
        : false;
    this.showNAFields = countryId == 23 || countryId == null ? false : true;
    
    if (!isEditData) {
      this.isValueChange = true;
      countryId == 23
        ? this.subscriptionForm.controls['CurrencyID'].setValue(4)
        : this.subscriptionForm.controls['CurrencyID'].setValue(null);
    } else {
      this.subscriptionForm.controls['CurrencyID'].setValue(
        this.editSubscriptionData.CurrencyID
      );
    }
    this.enableDisablePricingAdd();
    this.showPPMDAsTextInput =
      countryId == 23 || countryId == 259 || countryId == 265 || countryId == 267 || countryId == 268 || countryId == 269 ? false : true;
    if (countryId == 23 || countryId == 259 || countryId == 265 || countryId == 267 || countryId == 268 || countryId == 269) {
      this.isUSCountry = true;
      this.subscriptionForm.controls['subscriptionPPMD'].setValidators([
        Validators.required,
      ]);
    } else {
      this.isUSCountry = false;
      this.subscriptionForm.controls['subscriptionPPMD'].clearValidators();
      if (!isEditData) {
        this.subscriptionForm.controls['subscriptionPPMD'].setValue(null);
      }
    }
    this.subscriptionForm.controls['subscriptionPPMD'].updateValueAndValidity();
    this.loadServiceFunctionDropdown();
    this.loadIndustryDropdown();
    if (this.isSubmitted) {
      this.checkValidCompany();
    }
    this.updateWBSMandatoryStatus();
  }

  updateWBSMandatoryStatus() {
    // For subscription module, WBS is mandatory only when:
    //  Sponsoring country is US (23)
   
   
    
    if (
      this.subscriptionForm.controls['SponsoringCountryID'].value == 23
    ) {
      this.isWBSMandatory = true;
    } else {
      this.isWBSMandatory = false;
    }
  }

  loadServiceFunctionDropdown(): void {
    if (this.masterData && this.masterData.ServiceFunctions.length > 0) {
      if (this.showNAFields) {
        this.serviceFunctionList = this.masterData.ServiceFunctions.filter(
          (data) => !data.IsMDR && data.IsActive
        );
      } else {
        if (
          this.session.serviceLineFunction != null &&
          this.session.serviceLineFunction != undefined &&
          this.session.serviceLineFunction == 20
        ) {
          this.session.serviceLineFunction = null;
        }

        this.serviceFunctionList = this.masterData.ServiceFunctions.filter(
          (data) => !data.IsMDR && data.IsActive && !data.Name.includes('N/A')
        );
      }
    }
  }

  loadIndustryDropdown(): void {
    if (this.masterData && this.masterData.Industries.length > 0) {
      if (this.showNAFields) {
        this.industriesList = this.masterData.Industries.filter(
          (data) => !data.IsMDR && data.IsActive
        );
      } else {
        this.industriesList = this.masterData.Industries.filter(
          (data) => !data.IsMDR && data.IsActive && !data.Name.includes('N/A')
        );
      }
    }
  }

  industryChange(event, isChange?) {
    if (isChange) this.isValueChange = true;
    if (this.masterData && this.masterData.Industries.length > 0) {
      this.sectorList = this.masterData.Sectors.filter(
        (sector) => sector.IndustryID == event
      );
      this.session.sessionSector = null;
      const item = this.industriesList.find((index) => index.ID == event);
      this.session.sessionIndustry = item ? event : null;
      this.isIndustryNAMandatory = false;
      this.subscriptionForm.controls['IndustryText'].disable();
      this.subscriptionForm.controls['IndustryText'].clearValidators();
      if (item && item.Name.includes('N/A')) {
        this.isIndustryNAMandatory = true;
        this.subscriptionForm.controls['IndustryText'].enable();
        this.subscriptionForm.controls['IndustryText'].setValidators([
          Validators.required,
        ]);
        this.subscriptionForm.get('SectorID').setValue('40');
        this.session.sessionSector = this.sectorList[0].SectorID;
        this.onSectorChange(this.sectorList[0].SectorID);
      } else {
        isChange
          ? this.subscriptionForm.get('SectorID').setValue(null)
          : this.subscriptionForm
              .get('SectorID')
              .setValue(this.editSubscriptionData.SectorID);
        this.isSectorNAMandatory = false;
        this.subscriptionForm.controls['SectorText'].disable();
        this.subscriptionForm.controls['SectorText'].clearValidators();
      }
      this.subscriptionForm.controls['SectorText'].updateValueAndValidity();
      this.subscriptionForm.controls['IndustryText'].updateValueAndValidity();
    }
  }

  onSectorChange(id, isChange?) {
    if (isChange) this.isValueChange = true;
    if (this.sectorList && this.sectorList.length > 0) {
      const item = this.sectorList.find((index) => index.SectorID == id);
      this.isSectorNAMandatory = false;
      this.subscriptionForm.controls['SectorText'].disable();
      this.subscriptionForm.controls['SectorText'].clearValidators();
      if (item && item.SectorName.includes('N/A')) {
        this.isSectorNAMandatory = true;
        this.subscriptionForm.controls['SectorText'].enable();
        this.subscriptionForm.controls['SectorText'].setValidators([
          Validators.required,
        ]);
      }
      this.subscriptionForm.controls['SectorText'].updateValueAndValidity();
    }
  }

  onServiceFunctionChange(id) {
    this.isValueChange = true;
    if (this.serviceFunctionList && this.serviceFunctionList.length > 0) {
      const item = this.serviceFunctionList.find((index) => index.ID == id);
      this.isServiceNAMandatory = false;
      this.subscriptionForm.controls['ServiceFunctionText'].disable();
      this.subscriptionForm.controls['ServiceFunctionText'].clearValidators();
      if (item && item.Name.includes('N/A')) {
        this.isServiceNAMandatory = true;
        this.subscriptionForm.controls['ServiceFunctionText'].enable();
        this.subscriptionForm.controls['ServiceFunctionText'].setValidators([
          Validators.required,
        ]);
      }
      this.subscriptionForm.controls[
        'ServiceFunctionText'
      ].updateValueAndValidity();
    }
  }

  onSubmit(event): void {}

  onSubscriptionTypeChange(type: string): void {
    this.isValueChange = true;
    if (type === 'commercialization') {
      this.isCommType = true;
      this.subscriptionForm.controls['CompanyAdministrators'].setValidators([
        Validators.required,
      ]);
      this.subscriptionForm.controls['CompanyCoordinators'].setValidators([
        Validators.required,
      ]);
      this.subscriptionForm.controls['CompanyFacilitators'].setValidators([
        Validators.required,
      ]);
      this.subscriptionForm.controls['SubscriptionAdmins'].clearValidators();
    } else {
      this.selectedCompanyAdmins = [];
      this.selectedCompanyFacilitators = [];
      this.selectedSubCoordinators = [];
      this.subscriptionForm.controls['CompanyAdministrators'].clearValidators();
      this.subscriptionForm.controls['CompanyCoordinators'].clearValidators();
      this.subscriptionForm.controls['CompanyFacilitators'].clearValidators();
      if (this.selectedSubAdministrators.length == 0 && (this.selectedProposedSubAdmins == '' || this.selectedProposedSubAdmins == null )) {
        this.subscriptionForm.controls['SubscriptionAdmins'].setValidators([
          Validators.required,
        ]);
        this.subscriptionForm.controls['ProposedSubscriptionAdmins'].setValidators([
          Validators.required,
        ]);
      } else {
        this.subscriptionForm.controls['SubscriptionAdmins'].clearValidators();
        this.subscriptionForm.controls['ProposedSubscriptionAdmins'].clearValidators();
      }
      this.isCommType = false;
    }
    this.subscriptionForm.controls[
      'CompanyAdministrators'
    ].updateValueAndValidity();
    this.subscriptionForm.controls[
      'CompanyCoordinators'
    ].updateValueAndValidity();
    this.subscriptionForm.controls[
      'CompanyFacilitators'
    ].updateValueAndValidity();
    this.subscriptionForm.controls[
      'SubscriptionAdmins'
    ].updateValueAndValidity();
    this.subscriptionForm.controls[
      'ProposedSubscriptionAdmins'
    ].updateValueAndValidity();
  }

  updateSubPPMD(selectedData) {
    this.isValueChange = true;
    this.isInValidSubPPMD = false;
    this.PPMDFirstName = selectedData.item.Name_First;
    this.PPMDLastName = selectedData.item.Name_Last;
    this.PPMDEmail = selectedData.item.AD_EmailAdress;
    this.ppmdFirstLastName = `${this.PPMDFirstName} ${this.PPMDLastName}`;
  }

  searchPPMD = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((term) => {
        this.textLimitErrorPPMD =
          term && term.length > 0 && term.length < 3 ? true : false;
        return this.addSubscriptionService.getPPMDs(term, 1).pipe(
          catchError(() => {
            return of([]);
          })
        );
      })
    );

  formatPPMD = (value: any) =>
    value && value.AD_EmailAdress
      ? value.Name_First +
        ' ' +
        value.Name_Last +
        ' ' +
        '(' +
        value.AD_EmailAdress +
        ')'
      : '';
  formatPPMDSelection = (value: any) => {
    if (value && value.Name_First && value.Name_Last) {
      return value.Name_First + ' ' + value.Name_Last;
    }
    return '';
  };

  updateSubAdmins(event, operation, stopExecution?): void {
    this.isValueChange = true;
    const item = event.item ? event.item : event;
    if (item && operation) {
      if (operation == 'add') {
        const existingEmail = this.selectedSubAdministrators.find(
          (data) => data.Email.toLowerCase() == item.Email.toLowerCase()
        );
        if (!existingEmail) {
          this.selectedSubAdministrators.push(item);
        }
      }
      if (operation == 'delete') {
        this.selectedSubAdministrators = this.selectedSubAdministrators.filter(
          (data) => data.ID != item.ID
        );
      }
    }

    if (event.item && stopExecution) {
      event.preventDefault();
    }
    if (this.selectedSubAdministrators.length > 0 || (this.selectedProposedSubAdmins != '' && this.selectedProposedSubAdmins != null)) {
      this.subscriptionForm.controls['SubscriptionAdmins'].clearValidators();
      this.subscriptionForm.controls['ProposedSubscriptionAdmins'].clearValidators();
    } else if (!this.isCommType) {
      this.subscriptionForm.controls['SubscriptionAdmins'].setValidators([
        Validators.required,
      ]);
      this.subscriptionForm.controls['ProposedSubscriptionAdmins'].setValidators([
        Validators.required,
      ]);
    }
    this.subscriptionForm.controls['ProposedSubscriptionAdmins'].updateValueAndValidity();
    this.subscriptionForm.controls['SubscriptionAdmins'].setValue(null);
  }

  searchAdmin = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term) =>
        this.addSubscriptionService.searchAdminData(term, 1).pipe(
          map((res: any) => {
            if (this.userRoleID == 3) {
              const sponsoredCountry = this.subscriptionForm.controls[
                'SponsoringCountryID'
              ].value
                ? this.subscriptionForm.controls['SponsoringCountryID'].value
                : '';
              res = res.filter(
                (result) => result.CountryID == sponsoredCountry
              );
            }
            return res;
          }),
          catchError(() => {
            return of([]);
          })
        )
      )
    );

  formatRoles = (value: any) =>
    value
      ? value.FirstName + ' ' + value.LastName + ' ' + '(' + value.Email + ')'
      : '';

  updateCompanyFacilitators(event, operation, stopExecution?): void {
    this.isValueChange = true;
    this.isInValidCompFacilitator = false;
    const item = event.item ? event.item : event;
    if (item && operation) {
      if (operation == 'add') {
        const existingEmail = this.selectedCompanyFacilitators.find(
          (data) => data.Email.toLowerCase() == item.Email.toLowerCase()
        );
        if (!existingEmail) {
          this.selectedCompanyFacilitators.push(item);
        }
      }
      if (operation == 'delete') {
        this.selectedCompanyFacilitators =
          this.selectedCompanyFacilitators.filter((data) => data.ID != item.ID);
      }
    }

    if (event.item && stopExecution) {
      event.preventDefault();
    }
    if (this.selectedCompanyFacilitators.length > 0) {
      this.subscriptionForm.controls['CompanyFacilitators'].clearValidators();
    } else {
      this.subscriptionForm.controls['CompanyFacilitators'].setValidators([
        Validators.required,
      ]);
    }
    this.subscriptionForm.controls['CompanyFacilitators'].setValue(null);
  }

  searchFacilitators = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term) =>
        this.addSubscriptionService.getRoles(term, true).pipe(
          catchError(() => {
            return of([]);
          })
        )
      )
    );

  updateSubCoordinators(event, operation, stopExecution?): void {
    this.isValueChange = true;
    const item = event.item ? event.item : event;
    this.isInValidCompCo = false;
    if (item && operation) {
      if (operation == 'add') {
        const existingEmail = this.selectedSubCoordinators.find(
          (data) => data.Email.toLowerCase() == item.Email.toLowerCase()
        );
        if (!existingEmail) {
          this.selectedSubCoordinators.push(item);
        }
      }
      if (operation == 'delete') {
        this.selectedSubCoordinators = this.selectedSubCoordinators.filter(
          (data) => data.ID != item.ID
        );
      }
    }
    if (event.item && stopExecution) {
      event.preventDefault();
    }
    if (this.selectedSubCoordinators.length > 0) {
      this.subscriptionForm.controls['CompanyCoordinators'].clearValidators();
    } else {
      this.subscriptionForm.controls['CompanyCoordinators'].setValidators([
        Validators.required,
      ]);
    }
    this.subscriptionForm.controls['CompanyCoordinators'].setValue(null);
  }

  updateCompanyAdmins(event, operation, stopExecution?): void {
    this.isValueChange = true;
    this.isInValidCompAdmin = false;
    const item = event.item ? event.item : event;
    if (item && operation) {
      if (operation == 'add') {
        const existingEmail = this.selectedCompanyAdmins.find(
          (data) => data.Email.toLowerCase() == item.Email.toLowerCase()
        );
        if (!existingEmail) {
          this.selectedCompanyAdmins.push(item);
        }
      }
      if (operation == 'delete') {
        this.selectedCompanyAdmins = this.selectedCompanyAdmins.filter(
          (data) => data.ID != item.ID
        );
      }
    }
    if (event.item && stopExecution) {
      event.preventDefault();
    }
    if (this.selectedCompanyAdmins.length > 0) {
      this.subscriptionForm.controls['CompanyAdministrators'].clearValidators();
    } else {
      this.subscriptionForm.controls['CompanyAdministrators'].setValidators([
        Validators.required,
      ]);
    }
    this.subscriptionForm.controls['CompanyAdministrators'].setValue(null);
  }

  searchSubCooridnatorsAndCompanyAdmins = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term) =>
        this.addSubscriptionService.getRoles(term, false).pipe(
          catchError(() => {
            return of([]);
          })
        )
      )
    );

  onNoOfSessionsChange(type: string): void {
    this.isValueChange = true;
    this.associateSessionIsChecked = false;
    this.selectAllCheckboxDisabled = type == 'singleLink' ? true : false;
    if (this.isEditMode) {
      this.disableAssosiateSession = this.editSubscriptionData.TotalSessions >= 1 && this.subscriptionForm.controls["LinkType"].value == "singleLink" ? true : false;
    }
    }

  openPricingModal(type: string, values?): void {
    if (type === 'add' && !this.isPrepaid) {
      this.showLoader = true;
      this.getPricingInfo();
    } else {
      let date = this.subscriptionForm.controls['StartDate']
        ? this.subscriptionForm.controls['StartDate'].value
        : '';
      if (date != '') {
        date = new Date(date.year, date.month - 1, date.day);
      }
      let endDate = this.subscriptionForm.controls['EndDate']
        ? this.subscriptionForm.controls['EndDate'].value
        : '';
      if (endDate != '') {
        endDate = new Date(endDate.year, endDate.month - 1, endDate.day);
      }
      const modalRef = this.modalService.open(AddEditPricingModalComponent, {
        windowClass: 'pricing-modal',
      });
      modalRef.componentInstance.type = type;
      modalRef.componentInstance.pricingOption =
        this.subscriptionForm.controls['Pricingoption'].value;
      modalRef.componentInstance.currencySign = this.getCurrencySign();
      modalRef.componentInstance.startDate = this.datepipe.transform(
        date,
        'MM/dd/yyyy'
      );
      modalRef.componentInstance.editData = values ? values : {};
      modalRef.componentInstance.tableLength = this.pricingTableData.length;
      modalRef.componentInstance.isEditMode = this.isEditMode;
      modalRef.componentInstance.userRoleID = this.userRoleID;
      modalRef.componentInstance.sponsoringCountry = this.subscriptionForm.controls['SponsoringCountryID'].value;
      modalRef.componentInstance.isWBSMandatory = this.isWBSMandatory;
      modalRef.componentInstance.isStatusActive = this.subscriptionForm?.controls['Status']?.value === 'Active';
      modalRef.componentInstance.isSubscriptionStatusNew = !this.isEditMode || this.subscriptionForm?.controls['Status']?.value === 'New';
      modalRef.componentInstance.isSubscriptionCreatedBeforeMdmWbsDeploymentDate = this.isSubscriptionCreatedBeforeMdmWbsDeploymentDate;
      modalRef.componentInstance.eventLink = this.eventLink;
      modalRef.componentInstance.endDate = this.datepipe.transform(
        endDate,
        'MM/dd/yyyy'
      );
      const tempPricingData = JSON.parse(JSON.stringify(this.pricingTableData));
      modalRef.componentInstance.pricingDetails.subscribe((res) => {
        if (res) {
          this.wbsCodesList = [];
          this.surchargeWbsCodeList = [];
          this.isSurchargeWbsCodes = false;
          this.TotalChargeback = 0;
          this.TotalNumberOfUsers = 0;
          this.TotalActualUsage = 0;
          this.TotalSurcharge = 0;
          if (
            this.pricingTableData.find(
              (data) => data['id'] && res.id == data['id']
            )
          ) {
            const index = this.pricingTableData.indexOf(
              this.pricingTableData.find(
                (data) => data['id'] && res.id == data['id']
              )
            );
            this.pricingTableData[index] = res;
          } else {
            this.pricingTableData.push(res);
            if (
              new Date(res.DateOfPurchase) > new Date() ||
              (type == 'add' && !this.isEditMode && this.isPrepaid)
            ) {
              this.enableAdd = false;
            }
          }
          this.pricingTableData.forEach((data) => {
            data.wbsCodesText = this.displayWbsCodes(data);
            if (!this.isPrepaid) data.durationText = this.displayDuration(data);
            this.TotalChargeback += data.ChargeBack;
            this.TotalNumberOfUsers += data.NoOfUsers;
            this.TotalActualUsage += data.ActualUsage;
            if (data.Surcharge > 0) {
              this.TotalSurcharge += data.Surcharge;
            }
          });
          if (
            JSON.stringify(tempPricingData) !==
            JSON.stringify(this.pricingTableData)
          )
            this.isValueChange = true;
        }

      });
    }
  }

  displayDuration(values): string {
    let tempVal: string = '';
    tempVal = `${this.datepipe.transform(
      new Date(values.StartDate),
      'MM/dd/yyyy'
    )} - ${this.datepipe.transform(new Date(values.EndDate), 'MM/dd/yyyy')}`;
    if (this.subscriptionForm.controls['PaymenttermsID'].value != 4) {
      tempVal = `${tempVal} (${values.FiscalYear} ${values.QuarterOrPeriod})`;
    }
    return tempVal;
  }
  getCurrencySign(): string {
    const currencyValue = this.currencyList.find(
      (res) => res.value == +this.subscriptionForm.controls['CurrencyID'].value
    ).name;
    return currencyValue.slice(
      currencyValue.indexOf('(') + 1,
      currencyValue.indexOf('(') + 2
    );
  }

  onPriceOptionChange(value: string, isChange?): void {
    if (isChange) this.isValueChange = true;
    if (value === 'Prepaid') {
      this.showRefresh = false;
      this.isRefreshClicked = true;
      this.isPrepaid = true;
      this.paymentTerms = this.paymentTermsList.filter(
        (term) => term.name !== 'Periodic' && term.name !== 'Quarterly'
      );
      if (isChange) {
        this.subscriptionForm.controls['PaymenttermsID'].setValue(1);
        this.onPricingTermChange('1');
      } else {
        this.onPricingTermChange(
          this.editSubscriptionData.PaymenttermsID.toString()
        );
      }
    } else {
      this.isPrepaid = false;
      this.paymentTerms = this.paymentTermsList.filter(
        (term) => term.name !== 'Upfront'
      );
      this.subscriptionForm.controls['PaymenttermsID'].setValue(null);
      if (!isChange) {
        this.onPricingTermChange(
          this.editSubscriptionData.PaymenttermsID.toString()
        );
      }
    }
    if (isChange) {
      this.pricingTableData = [];
      this.subscriptionForm.controls['SponsoringCountryID'].value == '23'
        ? this.subscriptionForm.controls['CurrencyID'].setValue(4)
        : this.subscriptionForm.controls['CurrencyID'].setValue(null);
      this.onPricingTermChange(null);
    }
    if (this.editSubscriptionData?.CurrencyID) {
      this.subscriptionForm.controls['CurrencyID'].setValue(
        this.editSubscriptionData.CurrencyID
      );
    } else {
      this.subscriptionForm.controls['SponsoringCountryID'].value == '23'
        ? this.subscriptionForm.controls['CurrencyID'].setValue(4)
        : this.subscriptionForm.controls['CurrencyID'].setValue(null);
    }
    this.enableDisablePricingAdd();
  }

  onPricingTermChange(value: string, isChange?): void {
    const formCtrl = this.subscriptionForm.controls['PleaseSpecify'];
    if (+value == 4) {
      this.isPleaseSpecifyMandatory = true;
      formCtrl.enable();
      formCtrl.setValidators([Validators.required]);
    } else {
      this.isPleaseSpecifyMandatory = false;
      formCtrl.setValue('');
      formCtrl.disable();
      formCtrl.clearValidators();
    }
    formCtrl.updateValueAndValidity();
    if (isChange) {
      this.isValueChange = true;
      if (
        this.isEditMode &&
        !this.isPrepaid &&
        this.pricingTableData.length > 0
      ) {
        this.showRefresh = true;
        this.isRefreshClicked = false;
      } else {
        this.pricingTableData = [];
        this.subscriptionForm.controls['SponsoringCountryID'].value == '23'
          ? this.subscriptionForm.controls['CurrencyID'].setValue(4)
          : this.subscriptionForm.controls['CurrencyID'].setValue(null);
      }
    }
    this.enableDisablePricingAdd();
  }

  refreshPricingTable() {
    this.getPricingInfo();
    this.showRefresh = false;
    this.isRefreshClicked = true;
  }

  getPricingInfo(): void {
    let date = this.subscriptionForm.controls['StartDate']
      ? this.subscriptionForm.controls['StartDate'].value
      : '';
    if (date != '') {
      date = new Date(date.year, date.month - 1, date.day);
    }
    let endDate = this.subscriptionForm.controls['EndDate']
      ? this.subscriptionForm.controls['EndDate'].value
      : '';
    if (endDate != '') {
      endDate = new Date(endDate.year, endDate.month - 1, endDate.day);
    }
    const requestBody = {
      SubscriptionID: this.paramId ? this.paramId : 0,
      PaymentTermsID: this.subscriptionForm.controls['PaymenttermsID'].value,
      SubscriptionStartDate: this.datepipe.transform(date, 'yyyy-MM-dd'),
      SubscriptionEndDate: this.datepipe.transform(endDate, 'yyyy-MM-dd'),
    };
    this.TotalChargeback = 0;
    this.TotalNumberOfUsers = 0;
    this.TotalActualUsage = 0;
    this.TotalSurcharge = 0;
    this.addSubscriptionService
      .getPricingInformation(requestBody)
      .subscribe((res) => {
        this.showLoader = false;
        if (res) {
          this.pricingTableData = res;
          this.pricingTableData.forEach((data, i) => {
            data.id = i + 1;
            data.durationText = this.displayDuration(data);
            data.wbsCodesText = this.displayWbsCodes(data);
            this.TotalChargeback += data.ChargeBack;
            this.TotalNumberOfUsers += data.NoOfUsers;
            this.TotalActualUsage += data.ActualUsage;
            if (data.Surcharge > 0) {
              this.TotalSurcharge += data.Surcharge;
            }
          });
          if (this.isEditMode && this.pricingTableData.length > 0) {
            this.enableAdd = false;
            // Validate WBS codes after pricing data is loaded
            this.validateWBSCodesInPricing();
          }
        }
      });
  }

  validateWBSCodesInPricing(): Promise<void> {
    return new Promise((resolve) => {
      // Reset flag before validating
      this.hasInactiveWBSInPricing = false;
      this.inactiveWBSErrorMessage = '';

      if (!this.pricingTableData || this.pricingTableData.length === 0) {
        resolve();
        return;
      }

      const isStatusActive = this.subscriptionForm?.controls['Status']?.value === 'Active';

      // Collect all WBS codes that need validation with references to the objects
      const wbsCodesToValidate: { code: string, wbsObj: any, pricingIndex: number, isSurcharge: boolean }[] = [];

      this.pricingTableData.forEach((pricingRow, pricingIndex) => {
        // Check regular WBS codes
        if (pricingRow.WBSCodesList && pricingRow.WBSCodesList.length > 0) {
          pricingRow.WBSCodesList.forEach((wbs: any, wbsIndex: number) => {
            if (wbs.wbscode && wbs.wbscode.trim()) {
              wbsCodesToValidate.push({
                code: wbs.wbscode,
                wbsObj: wbs,
                pricingIndex: pricingIndex,
                isSurcharge: false
              });
            }
          });
        }

        // Check surcharge WBS codes
        if (pricingRow.SurchargeWBSCodesList && pricingRow.SurchargeWBSCodesList.length > 0) {
          pricingRow.SurchargeWBSCodesList.forEach((wbs: any, wbsIndex: number) => {
            if (wbs.wbscode && wbs.wbscode.trim()) {
              wbsCodesToValidate.push({
                code: wbs.wbscode,
                wbsObj: wbs,
                pricingIndex: pricingIndex,
                isSurcharge: true
              });
            }
          });
        }
      });

      // If no WBS codes to validate, resolve immediately
      if (wbsCodesToValidate.length === 0) {
        resolve();
        return;
      }

      // Track pending API calls
      let completedCalls = 0;
      const totalCalls = wbsCodesToValidate.filter(item => item.code.length >= 22).length;

      if (totalCalls === 0) {
        resolve();
        return;
      }

      // Validate each WBS code by calling the API
      wbsCodesToValidate.forEach((wbsItem) => {
        if (wbsItem.code.length >= 22) {
          this.addSubscriptionService.getWBSCodes(wbsItem.code).subscribe(
            (results) => {
              const normalizedRequest = this.normalizeWbsCode(wbsItem.code);
              const matches = (results || []).some((entry: any) => {
                const entryCode = this.normalizeWbsCode(
                  entry?.Element || entry?.WBSCode || entry?.wbsCode
                );
                return entryCode && entryCode === normalizedRequest;
              });

              // Store validation status directly on the WBS object
              wbsItem.wbsObj['isWbsStatusChecked'] = true;
              wbsItem.wbsObj['isWbsActive'] = matches;
              if (results && results.length > 0) {
                wbsItem.wbsObj['wbsDunsNumber'] = results[0].DunsNumber;
              }

              const isExistingWbs = wbsItem.wbsObj['isExistingWbs'] === true;
              const shouldIgnoreInactiveExistingWbs =
                this.isSubscriptionCreatedBeforeMdmWbsDeploymentDate && isExistingWbs;

              // Only raise errors for WBS codes that are NOT already linked to this subscription.
              // Inactive codes that were previously saved should remain as-is (non-editable / greyed out)
              // and must not block the form from being submitted.
              if (!matches  && !shouldIgnoreInactiveExistingWbs) {
                this.hasInactiveWBSInPricing = true;
                this.inactiveWBSErrorMessage = `Code(s) is no longer active`;
              }
              const resultElement = (results && results.length > 0 && results[0]?.Element
                ? String(results[0].Element)
                : '').toUpperCase().trim();
              //const skipDunsValidation =
              //  resultElement.startsWith('LPE') ||
              //  resultElement.startsWith('GAA') ||
              //  resultElement.startsWith('GEP');
              const skipDunsValidation = true;
              if (
                results &&
                results.length > 0 &&
                !skipDunsValidation &&
                results[0]?.DunsNumber != this.selectedCompanyDunsID
              ) {
                this.hasInactiveWBSInPricing = true;
                this.inactiveWBSErrorMessage = `Invalid WBS code - The selected WBS does not match the company's DunsID.`;
              }
              completedCalls++;
              // Resolve when all API calls are done
              if (completedCalls === totalCalls) {
                resolve();
              }
            },
            (error) => {
              // On error, consider WBS as inactive
              wbsItem.wbsObj['isWbsStatusChecked'] = true;
              wbsItem.wbsObj['isWbsActive'] = false;
              
              // Only block submission for codes that are not already linked to this subscription
              if (
                !(
                  this.isSubscriptionCreatedBeforeMdmWbsDeploymentDate &&
                  wbsItem.wbsObj['isExistingWbs'] === true
                )
              ) {
                this.hasInactiveWBSInPricing = true;
                this.inactiveWBSErrorMessage = `Code(s) is no longer active`;
              }
              
              completedCalls++;
              // Resolve when all API calls are done
              if (completedCalls === totalCalls) {
                resolve();
              }
            }
          );
        }
      });
    });
  }

  onPleaseSpecifyChange(value): void {
    this.isValueChange = true;
    this.subscriptionForm.controls['PleaseSpecify'].setValue(
      this.subscriptionForm.controls['PleaseSpecify'].value.replace(
        /^\s+|\s+$/gm,
        ''
      )
    );
    this.enableDisablePricingAdd();
  }

  onStatusChange(value: string): void {
    this.isValueChange = true;
    if (
      value !== 'Active' &&
      this.isEditMode &&
      this.editSubscriptionData.Expiredsessionscount > 0
    ) {
      const ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        centered: true,
      };
      const modalRef = this.modalService.open(
        ConfirmationDialogComponent,
        ngbModalOptions
      );
      modalRef.componentInstance.title = 'Warning';
      modalRef.componentInstance.message =
        'You have active sessions, have you change the status?';
      modalRef.componentInstance.btnOkText = 'OK';
      this.subscriptionForm.controls['Status'].setValue('Active');
    }
  }

  checkRolesValidation(): void {
    if (this.isCommType) {
      if (this.selectedCompanyFacilitators.length > 0) {
        this.subscriptionForm.controls['CompanyFacilitators'].clearValidators();
      } else {
        this.subscriptionForm.controls['CompanyFacilitators'].setValidators([
          Validators.required,
        ]);
      }
      this.subscriptionForm.controls[
        'CompanyFacilitators'
      ].updateValueAndValidity();
      if (this.selectedCompanyAdmins.length > 0) {
        this.subscriptionForm.controls[
          'CompanyAdministrators'
        ].clearValidators();
      } else {
        this.subscriptionForm.controls['CompanyAdministrators'].setValidators([
          Validators.required,
        ]);
      }
      this.subscriptionForm.controls[
        'CompanyAdministrators'
      ].updateValueAndValidity();
      if (this.selectedSubCoordinators.length > 0) {
        this.subscriptionForm.controls['CompanyCoordinators'].clearValidators();
      } else {
        this.subscriptionForm.controls['CompanyCoordinators'].setValidators([
          Validators.required,
        ]);
      }
      this.subscriptionForm.controls[
        'CompanyCoordinators'
      ].updateValueAndValidity();
    }
  }

  checkValidCompany(val?: string): void {
    const companyVal = this.subscriptionForm.controls['Company'].value;
    const audience = val
      ? val
      : this.subscriptionForm.controls['SessionAudience'].value;
    if (
      audience == 'ExternalClient' &&
      (this.subscriptionForm.controls['SponsoringCountryID'].value == '23' ||
        this.subscriptionForm.controls['SubscriptionType'].value ==
          'commercialization')
    ) {
      if (companyVal && companyVal.ID) {
        this.subscriptionForm.controls['Company'].setErrors(null);
      } else {
        if (this.isEditMode) {
          const text =
            typeof companyVal == 'string'
              ? companyVal.trim()
              : companyVal.Name.trim();
          this.addSubscriptionService
            .getCompanies(text, 0)
            .pipe(
              catchError(() => {
                return of([]);
              })
            )
            .subscribe((res) => {
              if (
                res &&
                res.length > 0 &&
                res.some((data) => data.Name == companyVal)
              ) {
                this.subscriptionForm.controls['Company'].setErrors(null);
              } else {
                this.subscriptionForm.controls['Company'].setErrors({
                  isInValid: true,
                });
              }
            });
        } else {
          if (this.isSubmitted)
            this.subscriptionForm.controls['Company'].setErrors({
              isInValid: true,
            });
        }
      }
    } else {
      const companyText =
        typeof companyVal == 'string'
          ? companyVal
          : companyVal
          ? companyVal.Name
          : '';
      if (companyText.replace(/^\s+|\s+$/gm, '') != '') {
        this.subscriptionForm.controls['Company'].setErrors(null);
      } else if (this.isSubmitted) {
        this.subscriptionForm.controls['Company'].setErrors({
          isInValid: true,
        });
      }
    }
  }

  checkValidDataInTypeAhead(): void {
    this.checkValidCompany();
    if (
      this.isCommType &&
      this.subscriptionForm.controls['CompanyAdministrators'].value != null &&
      this.subscriptionForm.controls['CompanyAdministrators'].value != ''
    ) {
      this.isInValidCompAdmin = true;
    } else {
      this.isInValidCompAdmin = false;
    }
    if (
      this.isCommType &&
      this.subscriptionForm.controls['CompanyCoordinators'].value != null &&
      this.subscriptionForm.controls['CompanyCoordinators'].value != ''
    ) {
      this.isInValidCompCo = true;
    } else {
      this.isInValidCompCo = false;
    }
    if (
      this.isCommType &&
      this.subscriptionForm.controls['CompanyFacilitators'].value != null &&
      this.subscriptionForm.controls['CompanyFacilitators'].value != ''
    ) {
      this.isInValidCompFacilitator = true;
    } else {
      this.isInValidCompFacilitator = false;
    }
    if (
      this.subscriptionForm.controls['subscriptionPPMD'].value &&
      this.isUSCountry
    ) {
      if (
        this.subscriptionForm.controls['subscriptionPPMD'].value.AD_EmailAdress
      ) {
        this.isInValidSubPPMD = false;
      } else {
        this.isInValidSubPPMD = true;
      }
    } else {
      this.isInValidSubPPMD = false;
    }
  }
  checkForValidForm() {
    if (!this.validForm) {
      const invalidFields = [];
      Object.keys(this.subscriptionForm.controls).forEach((key) => {
        const control = this.subscriptionForm.get(key);
        if (control && control.invalid) {
          invalidFields.push(key); // Collect the names of invalid fields
        }
      });

      // Optionally, display the invalid fields
      if (invalidFields.length == 0) {
        this.validForm = true;
      }
    }
  }
  validateSubsAdmin() {
    const isActiveStatus = this.subscriptionForm?.controls['Status'].value === 'Active';
    const hasNoAdmins = this.selectedSubAdministrators.length === 0;
    const hasInvalidEmails = this.invalidEmailFormat || this.invalidEmailDomain;
    const hasNoProposedAdmins = !this.selectedProposedSubAdmins || this.selectedProposedSubAdmins.trim() == '' || this.selectedProposedSubAdmins.trim() == null;

    // Check for user roles 1 or 3
    if (this.userRoleID === 1 || this.userRoleID === 3) {
      if (isActiveStatus) {
        this.validForm = !(hasNoAdmins || hasInvalidEmails);
      } else {
        this.validForm = !(hasNoAdmins && hasNoProposedAdmins) && !hasInvalidEmails;
      }
    } else {
      // For other user roles
      this.validForm = !(hasNoAdmins && hasNoProposedAdmins) && !hasInvalidEmails;
    }

    // Validate the form if the above conditions are met
    this.invalidSubsAdmin = false;
    if (this.validForm) {
      this.checkForValidForm();
    }
    else {
      this.invalidSubsAdmin = true;
    }
  }

  SaveSubscription(): void {
    this.showLoader = true;
    this.WBSCodeError = false;
    this.isSubmitted = true;
    this.pricingTableError = "";
    this.checkValidDataInTypeAhead();
    this.subscriptionForm.updateValueAndValidity();
    this.checkRolesValidation();
    if (!this.isCommType) {
      this.validateEmails();
      this.validateSubsAdmin();
    } else {
      this.checkForValidForm();
    }
    let breakLoop = false; // Flag to control the loop
    this.pricingTableData.forEach((data) => {
      if (breakLoop) return; // Check if we should break the loop
      data.wbsCodesText = this.displayWbsCodes(data);
      if ((this.userRoleID == 1 || this.userRoleID == 3) && (this.subscriptionForm.controls['SponsoringCountryID'].value == 23 && data.wbsCodesText == "")) {
          this.WBSCodeError = true; // No error if user role is 1 or 3
      } else {
        this.WBSCodeError = (((this.userRoleID != 1 && this.userRoleID != 3)) && this.isPrepaid && this.subscriptionForm.controls['SponsoringCountryID'].value == 23 && data.wbsCodesText == "" );
      }
      if (this.WBSCodeError) {
          breakLoop = true; // Set the flag to true to break the loop
      }
    });

    // Validate WBS codes asynchronously and then proceed with form validation
    this.validateWBSCodesInPricing().then(() => {
      setTimeout(() => {
        if (
          !this.IsDateInvalid &&
          !this.isInValidCompAdmin &&
          !this.isInValidCompCo &&
          !this.isInValidCompFacilitator &&
          !this.isInValidSubPPMD &&
          this.subscriptionForm.valid &&
          this.validForm &&
          !this.hasInactiveWBSInPricing
        ) {
          if (this.pricingTableData.length < 1 && this.isPrepaid) {
            this.showLoader = false;
            this.pricingTableError =
              'Click ADD in the Pricing Information section to add the number of users for the subscription.';
          }
          else if (this.pricingTableData.length < 1 && !this.isPrepaid && this.subscriptionForm.controls['SponsoringCountryID'].value == 23) {
            this.showLoader = false;
            this.pricingTableError =
              'Click EDIT in the Pricing Information section to add the WBS Codes for the subscription.';
          } else if (this.selectedOrphanSessionIds.length > 0 && !this.sessionsAssosiated) {
            this.showLoader = false;
            this.sessionAssosiationError = "Please click SAVE to associate the selected sessions."
          }
          else if (this.WBSCodeError) {
            this.showLoader = false;
            if (this.isPrepaid && this.pricingTableData.length < 1) {
              this.pricingTableError =
                'Click ADD in the Pricing Information to add the WBS Codes for the subscription.';
            } else {
              this.pricingTableError = 'Click EDIT in the Pricing Information section to add the WBS Codes for the subscription.';
            }
          }
          else if (this.hasInactiveWBSInPricing) {
            this.showLoader = false;
            this.pricingTableError = this.inactiveWBSErrorMessage;
          }
          else {
            if (this.pricingTableData.length < 1 && !this.isPrepaid) {
              this.isRefreshClicked = false;
            }
            const payload = this.subscriptionForm.getRawValue();
            payload.SubscriptionAdmins = this.selectedSubAdministrators;
            payload.CompanyAdministrators = this.selectedCompanyAdmins;
            payload.CompanyFacilitators = this.selectedCompanyFacilitators;
            payload.CompanyCoordinators = this.selectedSubCoordinators;
            if (payload.CompanyAdministrators)
              payload.CompanyAdministrators.forEach((admin) => {
                admin.CompanyID = payload.Company.ID;
                if (admin.MemberFirm || admin.Office) {
                  delete admin.Office;
                  delete admin.MemberFirm;
                }
              });
            if (payload.CompanyCoordinators)
              payload.CompanyCoordinators.forEach((admin) => {
                admin.CompanyID = payload.Company.ID;
                if (admin.MemberFirm || admin.Office) {
                  delete admin.Office;
                  delete admin.MemberFirm;
                }
              });
            if (payload.CompanyFacilitators)
              payload.CompanyFacilitators.forEach((admin) => {
                admin.CompanyID = payload.Company.ID;
                if (admin.MemberFirm || admin.Office) {
                  delete admin.Office;
                  delete admin.MemberFirm;
                }
              });

            payload.Company =
              typeof payload.Company == 'string'
                ? payload.Company
                : payload.Company.Name;
            payload.StartDate = payload.StartDate
              ? this.datepipe.transform(
                  new Date(
                    payload.StartDate.year,
                    payload.StartDate.month - 1,
                    payload.StartDate.day
                  ),
                  'yyyy-MM-dd'
                )
              : '';
            payload.EndDate = payload.EndDate
              ? this.datepipe.transform(
                  new Date(
                    payload.EndDate.year,
                    payload.EndDate.month - 1,
                    payload.EndDate.day
                  ),
                  'yyyy-MM-dd'
                )
              : '';
            this.subscriptionPpmdEmail =
              this.isUSCountry &&
              payload.subscriptionPPMD &&
              payload.subscriptionPPMD.AD_EmailAdress
                ? payload.subscriptionPPMD.AD_EmailAdress
                : payload.subscriptionPPMD;
            payload.PPMDEmail =
              payload.subscriptionPPMD && this.subscriptionPpmdEmail
                ? this.subscriptionPpmdEmail
                : '';
            payload.PPMDFirstName =
              payload.subscriptionPPMD && payload.subscriptionPPMD.Name_First
                ? payload.subscriptionPPMD.Name_First
                : '';
            payload.PPMDLastName =
              payload.subscriptionPPMD && payload.subscriptionPPMD.Name_Last
                ? payload.subscriptionPPMD.Name_Last
                : '';
            const pricingOptions = JSON.parse(
              JSON.stringify(this.pricingTableData)
            );
            pricingOptions.forEach((data) => {
              delete data.id;
              delete data.wbsCodesText;
              if (this.isPrepaid) {
                data.SurchargeWBSCodesList =
                  data.SurchargeWBSCodesList &&
                  data.SurchargeWBSCodesList.length > 0
                    ? data.SurchargeWBSCodesList[0].wbscode == ''
                      ? []
                      : data.SurchargeWBSCodesList
                    : [];
                data.DateOfPurchase = this.datepipe.transform(
                  new Date(data.DateOfPurchase.replace(/-/g, '/')),
                  'yyyy-MM-dd'
                );
              }
              data.WBSCodesList =
                data.WBSCodesList && data.WBSCodesList.length > 0
                  ? data.WBSCodesList[0].wbscode == ''
                    ? []
                    : data.WBSCodesList
                  : [];           
            });
            
            payload.CurrencyID = +payload.CurrencyID;
            payload.SponsoringCountryID = +payload.SponsoringCountryID;
            payload.BCMailBox = this.getCountryBCMailBox(
              payload.SponsoringCountryID
            );
            payload.PrepaidPricingInfo = this.isPrepaid ? pricingOptions : [];
            payload.OpenPricingInfo = !this.isPrepaid ? pricingOptions : [];
            payload.ID = this.paramId ? +this.paramId : 0;
            payload.IsRefreshClicked = this.isRefreshClicked;
            payload.ModifiedByUser = '';
            payload.CreatedByUser = '';
            payload.PriceperPerson = '';
            payload.Amount = '';
            payload.MaxUsers = 0;
            payload.WBSCodes = [];
            payload.createdBy = null;
            payload.SponsoringCountry = '';
            payload.Currency = '';
            payload.PaymentFrequency = '';
            payload.Expiredsessionscount = 0;
            payload.TotalSessions = 0;
            payload.SessionMaxEndDate = '';
            delete payload.subscriptionPPMD;
            this.addSubscriptionService.submitData(payload).subscribe((res) => {
              if (this.userRoleID == 1  && payload.Status == 'Active') {
                payload.SubscriptionuniqueID = res[1];
                this.downloadAcknowledgementEmail(payload);
              }
              this.showLoader = false;
              this.openSavePopUp();
            });
          }
        } else {
          this.showLoader = false;
          let topOffsetPostion;
          this.errorMessage = 'All required fields are mandatory';
          const formCtrl = this.subscriptionForm.controls;
          if (
            formCtrl['subscriptionPPMD'].invalid ||
            this.isInValidSubPPMD || this.invalidSubsAdmin ||
            (this.isInValidCompAdmin &&
              this.isInValidCompCo &&
              this.isInValidCompFacilitator) ||
            (this.isCommType &&
              (formCtrl['CompanyAdministrators'].invalid ||
                formCtrl['CompanyCoordinators'].invalid ||
                formCtrl['CompanyFacilitators'].invalid))
          ) {
            // $('#accordion .accordion3').collapse('show');
            const element = document.querySelector('#accordion .accordion3');
            if (element) {
              element.classList.add('show');
              element.classList.remove('collapse');
            }
            const tempScrollValue = $('#collapse3').offset().top - 190;
            topOffsetPostion = Math.ceil(tempScrollValue);
            $(window).scrollTop(topOffsetPostion);
          }
          if (
            formCtrl['PaymenttermsID'].invalid ||
            formCtrl['PleaseSpecify'].invalid ||
            formCtrl['Pricingoption'].invalid ||
            formCtrl['CurrencyID'].invalid ||
            this.pricingTableData.length === 0
          ) {
            // $('#accordion .accordion2').collapse('show');
            const element = document.querySelector('#accordion .accordion2');
            if (element) {
              element.classList.add('show');
              element.classList.remove('collapse');
            }
            const tempScrollValue = $('#collapse2').offset().top - 190;
            topOffsetPostion = Math.ceil(tempScrollValue);
            $(window).scrollTop(topOffsetPostion);
          }
          if (
            formCtrl['Company'].invalid ||
            formCtrl['EndDate'].invalid ||
            formCtrl['IndustryID'].invalid ||
            formCtrl['IndustryText'].invalid ||
            formCtrl['LinkType'].invalid ||
            formCtrl['SecRestrictedID'].invalid ||
            formCtrl['SectorID'].invalid ||
            formCtrl['SectorText'].invalid ||
            formCtrl['ServiceFunctionID'].invalid ||
            formCtrl['ServiceFunctionText'].invalid ||
            formCtrl['SponsoringCountryID'].invalid ||
            formCtrl['StartDate'].invalid ||
            formCtrl['SubscriptionType'].invalid
          ) {
            // $('#accordion .accordion2').collapse('show');
            const element = document.querySelector('#accordion .accordion1');
            if (element) {
              element.classList.add('show');
              element.classList.remove('collapse');
            }
            const tempScrollValue = $('#collapse1').offset().top - 210;
            topOffsetPostion = Math.ceil(tempScrollValue);
            $(window).scrollTop(topOffsetPostion);
          }
        }
      }, 2000);
    });
  }

  downloadAcknowledgementEmail(AddSessionInputs) {
    const emailSubject = 'Acknowledgement Letter Subscriptions';
    this.addSubscriptionService
      .emailDownload(AddSessionInputs, emailSubject)
      .subscribe((res) => {
        var binaryData = [];
        binaryData.push(res);
        const url = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'application/vnd.ms-excel' })
        );
        // create hidden dom element (so it works in all browsers)
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        // create file, attach to hidden element and open hidden element
        a.href = url;
        a.download = emailSubject + '.eml';
        a.click();
      });
  }

  close(): void {
    const formValues = JSON.stringify(this.subscriptionForm.value);
    if (this.userRoleID !== 6 && (this.initialFormValue !== formValues || this.isValueChange)) {
      const ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        centered: true,
      };
      const modalRef = this.modalService.open(
        ConfirmationDialogComponent,
        ngbModalOptions
      );
      modalRef.componentInstance.title = 'Confirmation';
      modalRef.componentInstance.message =
        'Any unsaved changes made will be lost. Are you sure?';
      modalRef.componentInstance.btnOkText = 'Yes';
      modalRef.componentInstance.btnCancelText = 'No';
      modalRef.componentInstance.btnCancelShow = true;
      modalRef.result.then((res) => {
        if (res) {
          this.router.navigate(['/searchSubscription']);
        }
      });
    } else {
      this.router.navigate(['/searchSubscription']);
    }
  }
  '';
  getCountryBCMailBox(countryId = ''): string {
    let bcMailBox = '';
    const country = this.sponsoringCountryList.find(
      (res) => res.ID == countryId
    );

    if (country) {
      bcMailBox = country.BCMailBox;
    }

    return bcMailBox;
  }

  onEdit(value): void {
    this.openPricingModal('edit', value);
  }

  displayWbsCodes(value): string {
    let tempValue = '';
    const arr = JSON.parse(
      JSON.stringify(
        value.WBSCodesList &&
          value.WBSCodesList.length > 0 &&
          value.WBSCodesList[0].wbscode != ''
          ? value.WBSCodesList
          : []
      )
    );
    if (
      value.SurchargeWBSCodesList != undefined &&
      value.SurchargeWBSCodesList.length > 0 &&
      value.SurchargeWBSCodesList[0].wbscode != ''
    ) {
      value.SurchargeWBSCodesList.forEach((res) => {
        arr.push(res);
      });
    }
    if (arr.length > 1) {
      tempValue = `${arr[0]['wbscode']}(${arr[0]['Description']}) + ${
        arr.length - 1
      }`;
    } else if (arr.length > 0 && arr[0].wbscode != '') {
      tempValue = `${arr[0]['wbscode']}`;
    } else {
      tempValue = '';
    }
    return tempValue;
  }

  openWbsCodes(values): void {
    this.modalService.open(this.wbsCodeContent);
    this.wbsCodesList =
      values.WBSCodesList &&
      values.WBSCodesList.length > 0 &&
      values.WBSCodesList[0].wbscode != ''
        ? values.WBSCodesList
        : [];
    if (
      values.SurchargeWBSCodesList !== undefined &&
      values.SurchargeWBSCodesList.length > 0 &&
      values.SurchargeWBSCodesList[0].wbscode != ''
    ) {
      this.isSurchargeWbsCodes = true;
      this.surchargeWbsCodeList = values.SurchargeWBSCodesList;
    }
  }

  validateServiceLineNAValue(): void {
    this.subscriptionForm.controls['ServiceFunctionText'].setValue(
      this.subscriptionForm.controls['ServiceFunctionText'].value.replace(
        /^\s+|\s+$/gm,
        ''
      )
    );
  }

  validateIndustryNAValue(): void {
    this.subscriptionForm.controls['IndustryText'].setValue(
      this.subscriptionForm.controls['IndustryText'].value.replace(
        /^\s+|\s+$/gm,
        ''
      )
    );
  }

  validateSectorNAValue(): void {
    this.subscriptionForm.controls['SectorText'].setValue(
      this.subscriptionForm.controls['SectorText'].value.replace(
        /^\s+|\s+$/gm,
        ''
      )
    );
  }
  //method to set varibale if the form values are changes
  setValueChange(): void {
    this.isValueChange = true;
  }
  //Changes for US 3417373
  disableEditButton(dateOfPurchase) {
    if (
      (dateOfPurchase == this.dateofPurchaseToDisableOnProd &&
      this.editSubscriptionData &&
      this.editSubscriptionData.SubscriptionuniqueID ===
        this.subscriptionToDisableRowOnProd &&
      window.location.host &&
      window.location.host.toLowerCase() ===
        'businesschemistryadmin.deloitte.com') ||
      (this.isEditMode && this.userRoleID == 6 )
    ) {
      return true;
    } else return false;
  }
  handleSessionNameGeneration() {
    const payload = this.subscriptionForm.getRawValue();
    const company =
      typeof payload.Company == 'string'
        ? payload.Company
        : payload.Company.Name;
    const serviceLineText = payload.ServiceFunctionText;
    const serviceLineID = payload.ServiceFunctionID;
    const date = payload.StartDate;
    if (
      date &&
      serviceLineID &&
      company
    ) {
   
      
      const serviceLine =
        serviceLineID == 20
          ? serviceLineText
          : this.serviceFunctionList.find(
            (index) => index.ID == serviceLineID
          ).Name;
    //const serviceLine =
    //  serviceLineID == 26
    //    ? serviceLineText
    //    : serviceLineID;

    if (company && serviceLine) {
        const subsName =
          company +
          ' - ' +
        serviceLine +
          ' - ' +
        this.dateToString(date);

      this.subscriptionForm.controls['SubscriptionName'].setValue(subsName);
      }
    }
  }
  private dateToString = (date) => {
    const tempDay = date.day ? date.day : date.trim().split('-')[1];
    const tempMonth = date.month ? date.month : date.trim().split('-')[0];
    const year = date.year ? date.year : date.trim().split('-')[2];
    const day = tempDay.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    const month = tempMonth.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    return `${month}.${day}.${year}`;
  };
  setProposedSubAdmins() {
    
    //var email = this.subscriptionForm.controls['ProposedSubscriptionAdmins'].value;
    //if (this.subdomains.indexOf(email.split("@")[1].toLowerCase()) > -1) {

    //}
   
    if (this.selectedSubAdministrators.length > 0 || (this.selectedProposedSubAdmins != '' && this.selectedProposedSubAdmins != null )) {
      this.subscriptionForm.controls['SubscriptionAdmins'].clearValidators();
      this.subscriptionForm.controls['ProposedSubscriptionAdmins'].clearValidators();
    }
    if (this.selectedSubAdministrators.length == 0 && (this.selectedProposedSubAdmins == '' || this.selectedProposedSubAdmins == null )) {
      this.subscriptionForm.controls['SubscriptionAdmins'].setValidators([
        Validators.required,
      ]);
      this.subscriptionForm.controls['ProposedSubscriptionAdmins'].setValidators([
        Validators.required,
      ]);
    }
    // Ensure the form control validity is recalculated
    this.subscriptionForm.controls['SubscriptionAdmins'].updateValueAndValidity();
    this.subscriptionForm.controls['ProposedSubscriptionAdmins'].updateValueAndValidity();
  }
  validateEmails() {
    var subdomains = this.subdomains;
    this.invalidEmailFormat = false;
    this.invalidEmailDomain = false;
    this.selectedProposedSubAdmins = this.subscriptionForm.controls['ProposedSubscriptionAdmins'].value as string;
    var value = this.subscriptionForm.controls['ProposedSubscriptionAdmins'].value;
    //if (!if(emails){) {
    //  this.invalidEmailFormat = true;; // No value, no validation error
    //}
    if (value != "" && value != null) {
      // Split the input by semicolon
      const emails = value?.split(';').map(email => email.trim());

      // Regular expression for validating email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      for (const email of emails) {
        if (!emailRegex.test(email)) {
          this.invalidEmailFormat = true;  // Invalid email format
        }

        // Extract the domain from the email
        const domain = email.split('@')[1];
        if (!subdomains.includes(domain)) {
          this.invalidEmailDomain = true; // Domain not in the allowed list
        }
      }

      if (!this.invalidEmailDomain && !this.invalidEmailFormat) {
        this.setProposedSubAdmins();
      } else {
        this.subscriptionForm.controls['ProposedSubscriptionAdmins'].setValidators([
          Validators.required,
        ]);
        this.subscriptionForm.controls['ProposedSubscriptionAdmins'].updateValueAndValidity();
      }
    } else {
      this.setProposedSubAdmins();
    }
    //return null; // All emails are valid
  
}
  afterPopupClose() {
    if (this.userRoleID == 1 || this.userRoleID == 3 || this.userRoleID == 6) {
      this.router.navigate(['/searchSubscription']);
    } else {
      this.router.navigate(['/searchSession']);
    }
  }
  removeBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  }
  navigateToSecurity() {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/security']));
    window.open(url, '_blank');
  }
  openSavePopUp() {
    const save_session = new Modal(document.getElementById('save_subscription'));
    
    save_session.show();
      $(".modal-backdrop").remove();
    this.removeBackdrop();
  }
  ngOnDestroy() {
    this.subscription.next();
    this.subscription.complete();
    this.userRoleService.setDisableUserRoleList(false);
  }
  showOrphanSessions(event: Event) {
    const input = event.target as HTMLInputElement;
    this.associateSessionIsChecked = input.checked;
    if (this.associateSessionIsChecked) {
      this.showLoader = true;
      const payload = this.subscriptionForm.getRawValue();
      const Company =
        typeof payload.Company == 'string'
          ? payload.Company
          : payload.Company.Name;
      const SubscriptionID = Number(this.editSubscriptionData.SubscriptionuniqueID);
      this.addSubscriptionService
        .getSessionsForSubAssociation(Company, SubscriptionID)
        .subscribe((res) => {
          if (res) {
            this.sessionData = res.Data;
            this.sampleData = res.Data; 
            this.showLoader = false;
            this.selectAllCheckboxDisabled = this.subscriptionForm.controls['LinkType'].value == 'singlelink' ? true : false;
          }
        });
    }
  }
  searchSession(event: Event) {
    const input = event.target as HTMLInputElement;
    const sessionName = input.value;
    this.sampleData = this.sessionData;
    if (sessionName != "") {
      const filteredSessions: any = this.sampleData.filter(
        (session: OrphanSessionData) => session.SessionName.toLowerCase().includes(sessionName.toLowerCase())
      );
      this.sampleData = filteredSessions;
    } else {
      this.sampleData = this.sessionData;
    }
  }
  selectedOrphanSessionIds: number[] = [];
  rowCheckboxClickEvent(data) {
    if (data.checked == true) {
      this.selectedOrphanSessionIds.push(data.SessionId);
      
    } else if (this.selectedOrphanSessionIds.indexOf(data.SessionId) != -1) {
      this.selectedOrphanSessionIds.splice(
        this.selectedOrphanSessionIds.indexOf(data.SessionId),
        1
      );
    }
    this.disableAddAssosiateSession = this.selectedOrphanSessionIds.length > 0 ? false : true;
  }
  onSelectAllClick(data) {
    this.selectedOrphanSessionIds = [];
    data.forEach((item) => {
      if (item.checked == false) this.selectedOrphanSessionIds = [];
      if (item.checked == true)
        this.selectedOrphanSessionIds.push(item.SessionId);
    });
    this.disableAddAssosiateSession = this.selectedOrphanSessionIds.length > 0 ? false : true;
  }
  assosiateSessions() {
    this.showLoader = true;
    const sessionsList: AssignSessionsToSubsInputDTO = {
      sessionIds: this.selectedOrphanSessionIds,
      subscriptionID: Number(this.editSubscriptionData.SubscriptionuniqueID),
    };

    this.addSubscriptionService.assignSessionsToSubscription(sessionsList)
      .subscribe(
        (response) => {
          this.showLoader = false;
          if (response.Success) {
            this.sessionsAssosiated = true;
            this.associateSessionIsChecked = false;
            this.disableAddAssosiateSession = true;
          }
          console.log('Sessions assigned successfully:', response.Data);
        },
        (error) => {
          this.showLoader = false;
          console.error('Error assigning sessions:', error);
        }
      );
  }
  getFiscalYear(dateOfPurchase: string): string {
    const date = new Date(dateOfPurchase);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // getMonth() is zero-based

    // Fiscal year starts in June
    const fiscalYear = month >= 6 ? year : year - 1;
    return `FY${fiscalYear.toString().slice(-2)}`;
  }
  setColumnHeading() {
    this.sampleColumns = [
      {
        name: "SessionName",
        header: "Session Name",
        dataType: "string",
        minWidth: "100px",
      },
      {
        name: "SessionDate",
        header: "Session Date",
        dataType: "date",
        minWidth: "100px",
      },

      {
        name: "City",
        header: "City",
        dataType: "string",
        minWidth: "60px",
      },
      {
        name: "FacilatorId",
        header: "Facilitator",
        dataType: "string",
        minWidth: "60px",
      },
      {
        name: "CoordinatorId",
        header: "Coordinator",
        dataType: "string",
        minWidth: "100px",
      },
      {
        name: "SessionType",
        header: "Session Audience",
        dataType: "string",
        minWidth: "100px",
      },
      {
        name: "ExternalExecutive",
        header: "Anticipated",
        dataType: "string",
        minWidth: "80px",
      },
      {
        name: "ActualUsage",
        header: "Actual Usage",
        dataType: "number",
        minWidth: "100px",
      },
      {
        name: "UniqueIdentifier",
        header: "Session ID",
        dataType: "string",
        minWidth: "100px",
      },
      {
        name: "EventId",
        header: "Event ID",
        dataType: "number",
        minWidth: "100px",
      }

    ];
  }
}
